import React from 'react';
import { Tag, Popover } from '@arco-design/web-react';

// StatusIcon 组件
export function StatusIcon({ status, progress = 0 }) {
  // 优先根据progress判断，如果progress为100%，显示绿色完成图标
  if (progress === 100) {
    return (
      <svg width="20" height="20">
        <circle cx="10" cy="10" r="8" fill="#fff" stroke="#52c41a" strokeWidth="2" />
        <path d="M7 10l2 2 4-4" stroke="#52c41a" strokeWidth="2" fill="none"/>
      </svg>
    );
  }
  
  // 如果进度在0-100之间，显示黄色进度弧线
  if (progress > 0 && progress < 100) {
    // 计算弧线角度，progress百分比转换为角度（0-360度）
    const angle = (progress / 100) * 360;
    const radians = (angle - 90) * (Math.PI / 180); // -90度是为了从顶部开始
    const x = 10 + 8 * Math.cos(radians);
    const y = 10 + 8 * Math.sin(radians);
    const largeArcFlag = angle > 180 ? 1 : 0;
    
    return (
      <svg width="20" height="20">
        <circle cx="10" cy="10" r="8" fill="#fff" stroke="#faad14" strokeWidth="2" opacity="0.3"/>
        <path
          d={`M10 2 A8 8 0 ${largeArcFlag} 1 ${x} ${y}`}
          stroke="#faad14"
          strokeWidth="2.5"
          fill="none"
        />
      </svg>
    );
  }
  
  // 如果没有progress数据，则根据status判断
  if (status === 'success') {
    return (
      <svg width="20" height="20">
        <circle cx="10" cy="10" r="8" fill="#fff" stroke="#52c41a" strokeWidth="2" />
        <path d="M7 10l2 2 4-4" stroke="#52c41a" strokeWidth="2" fill="none"/>
      </svg>
    );
  }
  
  // 默认状态（进度为0或pending状态）
  if (status === 'pending' || progress === 0) {
    return (
      <svg width="20" height="20">
        <circle cx="10" cy="10" r="8" fill="#fff" stroke="#1890ff" strokeWidth="2" />
        <polygon points="8,7 14,10 8,13" fill="#1890ff"/>
      </svg>
    );
  }
  
  // 兜底处理
  if (status === 'processing') {
    return (
      <svg width="20" height="20">
        <circle cx="10" cy="10" r="8" fill="#fff" stroke="#faad14" strokeWidth="2" opacity="0.3"/>
        <path
          d="M10 2
             a8 8 0 0 1 0 16"
          stroke="#faad14"
          strokeWidth="2.5"
          fill="none"
        />
      </svg>
    );
  }
  
  return null;
}

// PlatformIcon 组件
export function PlatformIcon({ platform }) {
  
  
  // 支持多种平台值格式
  if (platform === 'douyin' || platform === 'dy' || platform === '抖音') {
    return <img src="/dy.eed2acf9c4e7be6a4e3e6dff0b29f0e9.svg" alt="抖音" style={{ width: 24 }} />;
  }
  if (platform === 'xiaohongshu' || platform === 'xhs' || platform === '小红书') {
    return <img src="/xhs.91bb28e9326512ff2563339c551fc98e.svg" alt="小红书" style={{ width: 24 }} />;
  }
  
  // 如果没有匹配的平台，显示默认图标或文本
  
  return <span style={{ fontSize: 12, color: '#999' }}>{platform || '未知'}</span>;
}

// StatusTag 组件
export function StatusTag({ 
  value, 
  options, 
  onChange, 
  record 
}) {
  // 找到当前状态对应的配置
  const current = options.find(opt => opt.value === value) || options[0];
  
  // 弹出菜单的内容
  const content = (
    <div>
      {options.map(opt => (
        <div
          key={opt.value}
          style={{
            padding: '6px 16px',
            cursor: 'pointer',
            color: opt.color,
            fontWeight: current.value === opt.value ? 'bold' : '300',
            background: current.value === opt.value ? '#f2f3f5' : 'transparent',
            borderRadius: 4
          }}
          onClick={() => onChange(opt.value, record)}
        >
          {opt.label}
        </div>
      ))}
    </div>
  );
  
  // 根据状态颜色决定 Tag 的颜色
  const getTagColor = (color) => {
    if (color === '#52c41a') return 'green';
    if (color === '#faad14') return 'orange';
    return 'default';
  };
  
  return (
    <Popover content={content} trigger="hover" position="br">
      <Tag 
        color={getTagColor(current.color)}
        style={{ cursor: 'pointer', minWidth: '80px' }}
      >
        {current.label}
      </Tag>
    </Popover>
  );
}

// 默认导出PlatformIcon以保持向后兼容
export default PlatformIcon;